import axios from '../../../http';

function initialState() {
  return {
    previousAddresses: [],
    residentialAddresses: {
      present: {
        manuallyEnterHome: false,
        mprn: null,
        mpan: null,
        lengthOfResidencyInMonths: null,
        line1: null,
        line2: null,
        county: null,
        city: null,
        postcode: null
      }
    },
    businessAddress: {
      manuallyEnterBilling: false,
      separateBilling: false,
      line1: null,
      line2: null,
      county: null,
      city: null,
      postcode: null
    }
  };
}

const state = initialState();

const getters = {};

const actions = {
  async getCustomerAddress ({ state, rootState, commit, dispatch }) {
    const { switchKey } = rootState.storage;

    try {
      const res = await axios({
        method: 'GET',
        url: '/request/switch/pro/info/address/v2',
        params: { switchKey }
      });
      const { mpan, mprn } = res.data.addressInfoDto.residentialAddresses.present;
      let mpanValid = null;

      if (mpan) {
        mpanValid = await dispatch('validMpan', mpan);
      }

      commit('updateState', {
        residentialAddresses: {
          ...res.data.addressInfoDto.residentialAddresses,
          lengthOfResidencyInMonths: null,
          manuallyEnterHome: false
        }
      });
      commit('personal_details_terms/updateState', {
        mpanNumber: mpan, mprnNumber: mprn, mpanValid
      }, { root: true });
    } catch (e) {

    }
  },
  async update ({ state, rootState, commit, dispatch }) {
    const { switchKey } = rootState.storage;

    try {
      const { status } = await axios({
        method: 'POST',
        url: '/request/switch/pro/update/address',
        data: {
          switchKey,
          ...state,
          businessAddress: state.businessAddress.separateBilling ? state.businessAddress : null,
          residentialAddresses: {
            present: state.residentialAddresses.present
          }
        }
      });

      if (status != 200) {
        throw 'address';
      }
    } catch (error) {
      throw 'address';
    }
  },
  async validMpan ({ rootState }, mpan) {
    const { switchKey } = rootState.storage;

    try {
      const { status, data } = await axios({
        method: 'GET',
        url: '/request/customer/mpan',
        params: { mpan }
      });

      return data || null;
    } catch (error) {
      return null;
    }
  },
  resetBillingAddress ({ commit }) {
    commit('resetBillingAddress');
  }
};

const mutations = {
  updateState (state, value) {
    state = Object.assign(state, value);
  },
  updateLookup (state, { prop, value }) {
    state.lookups = {
      ...state.lookups,
      [prop]: value
    };
  },
  updateRequesting (state, { prop, value }) {
    state.requesting[prop] = value;
  },
  resetBillingAddress (state) {
    state.businessAddress = {
      ...state.businessAddress,
      line1: null,
      line2: null,
      city: null,
      county: null,
      text: null
    }
  },
  resetState (state) {
    state = Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
